export default "__VITE_ASSET__Dw1E_Sn___"